<span>{{ options.displayItem(item) }}</span>